import { useQuery } from '@apollo/client'
import { TIMEZONE_OPTIONS } from 'constants'

import { queries } from '../graphql'

export const DEFAULT_TIMEZONE = 'America/Vancouver'

// Set of supported timezone values for O(1) lookup
const SUPPORTED_TIMEZONE_VALUES = new Set(TIMEZONE_OPTIONS.filter((tz) => tz.value !== 'auto').map((tz) => tz.value))

/**
 * Detect the browser's timezone and validate it against supported timezones
 * @returns {string} A supported IANA timezone identifier
 */
export const detectBrowserTimezone = () => {
  try {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    // Return browser timezone if it's in our supported list
    if (SUPPORTED_TIMEZONE_VALUES.has(browserTimezone)) {
      return browserTimezone
    }
    // Fall back to default if browser timezone is not supported
    return DEFAULT_TIMEZONE
  } catch {
    return DEFAULT_TIMEZONE
  }
}

/**
 * Hook to get the user's timezone from the me query
 * This ensures timezone is always fresh after profile updates,
 * unlike JWT-based timezone which requires re-login to refresh
 * @returns {string} The user's timezone or default
 */
export const useTimezone = () => {
  const { data } = useQuery(queries.user.me)
  return data?.me?.timezone ?? DEFAULT_TIMEZONE
}
